import { IS_NULL_OR_UNDEFINED } from './validation-utils';

export const TO_DOLLARS = (amountInCents: number): number => {
	if (IS_NULL_OR_UNDEFINED(amountInCents)) {
		return amountInCents;
	}
	return Math.round(amountInCents / 100);
};

export const TO_CENTS = (amountInDollars: number): number => {
	if (IS_NULL_OR_UNDEFINED(amountInDollars)) {
		return amountInDollars;
	}
	return Math.round(amountInDollars * 100);
};
